import React, { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnText } from "@/components/VnText/VnText";
import { I18nKeyType } from "@/i18n";

type OnboardingHeaderPropsType = {
  iconComponent: React.ReactNode;
  titleI18nKey: I18nKeyType | I18nKeyType[];
  titleI18nOptions?: object;
  descriptionI18nKey: I18nKeyType | I18nKeyType[] | null;
  descriptionI18nOptions?: object;
};

export const OnboardingHeader: FC<OnboardingHeaderPropsType> = ({
  iconComponent,
  titleI18nKey,
  titleI18nOptions,
  descriptionI18nKey,
  descriptionI18nOptions,
}) => (
  <>
    <VnBox className="flex w-full flex-row items-center gap-3">
      {iconComponent}
      <VnText
        variant="lgBold"
        className="text-xl"
        i18nKey={titleI18nKey}
        i18nOptions={titleI18nOptions}
      />
    </VnBox>
    {descriptionI18nKey && (
      <VnText
        variant="lg"
        className="text-muted-foreground"
        i18nKey={descriptionI18nKey}
        i18nOptions={descriptionI18nOptions}
      />
    )}
  </>
);
